import axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart, FaCheckCircle, FaTruck, FaTimesCircle } from 'react-icons/fa';
import LoadingScreen from '../../components/LoadingScreen';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3500';

function OrdersPage() {
    const [counts, setCounts] = useState({
        pendingOrdersCount: 0,
        confirmedOrdersCount: 0,
        shippedOrdersCount: 0,
        deliveredOrdersCount: 0,
        cancelledOrdersCount: 0
    });
    const [loading, setLoading] = useState(true);

    const handleApiError = (error) => {
        console.error('API Error:', error);
        alert(error.response?.data?.message || 'Something went wrong. Please try again.');
    };

    const handleOrderData = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('authToken');
            const response = await axios.get(`${API_BASE_URL}/counts`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setCounts(response.data);
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleOrderData();
    }, []);

    const orderStatusTiles = [
        { status: 'pending', title: 'PENDING ORDERS', count: counts.pendingOrdersCount, link: '/admin/pending-orders', icon: FaShoppingCart },
        { status: 'confirmed', title: 'CONFIRMED ORDERS', count: counts.confirmedOrdersCount, link: '/admin/confirmed-orders', icon: FaCheckCircle },
        { status: 'shipped', title: 'SHIPPED ORDERS', count: counts.shippedOrdersCount, link: '/admin/shipped-orders', icon: FaTruck },
        { status: 'delivered', title: 'DELIVERED ORDERS', count: counts.deliveredOrdersCount, link: '/admin/delivered-orders', icon: FaCheckCircle },
        { status: 'cancelled', title: 'CANCELLED ORDERS', count: counts.cancelledOrdersCount, link: '/admin/cancelled-orders', icon: FaTimesCircle }
    ];

    const totalOrders = orderStatusTiles.reduce((s, t) => s + (t.count || 0), 0);

    return (
        <Fragment>
            <div className="container-fluid p-3 pt-2 g-0 adma">
                <div className="row mb-4">
                    <div className="col-12">
                        <div className="section-title">
                            <h4 className='m-1'>ORDER MANAGEMENT</h4>
                            <p className="text-muted p-0 m-0">Manage and track all orders by their current status</p>
                        </div>
                    </div>
                </div>

                {loading ? (
                    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: 'calc(100vh - 220px)' }}>
                        <LoadingScreen />
                        <p className="mt-3 text-muted small fw-semibold" style={{ letterSpacing: '0.5px' }}>Loading order data...</p>
                    </div>
                ) : (
                    <>
                        {/* Order summary removed per request */}
                        <div className="row g-0 order-tiles-row">
                            {orderStatusTiles.map((item, index) => {
                                const Icon = item.icon;
                                const pct = totalOrders ? ((item.count / totalOrders) * 100).toFixed(1) : 0;
                                return (
                                    <div key={item.status} className="col-12 col-sm-6 col-md-4 col-xl">
                                        <Link to={item.link} className={`order-tile-card order-tile-${item.status} text-decoration-none`}>
                                            <div className="order-tile-top d-flex justify-content-between align-items-start mb-2">
                                                <div className="order-tile-icon-wrapper"><Icon className="order-tile-icon" /></div>
                                                <span className="order-tile-count">{item.count}</span>
                                            </div>
                                            <h6 className="order-tile-title mb-1">{item.title}</h6>
                                            <div className="order-tile-progress mt-2" aria-label="Status share" aria-valuenow={pct} aria-valuemin="0" aria-valuemax="100">
                                                <div className="order-tile-progress-bar" style={{ width: pct + '%' }}></div>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mt-3 small">
                                                <span className="text-muted">{pct}%</span>
                                                <span className="order-tile-link-label">VIEW</span>
                                            </div>
                                        </Link>
                                    </div>
                                );
                            })}
                        </div>
                    </>
                )}
            </div>
        </Fragment>
    );
}

export default OrdersPage;
